import React from 'react'

import { Icon } from '@clientbase/clientbase-library'
import { Box, Typography } from '@mui/material'
import { AccountsPayablePayee } from 'models/AccountsPayable'
import { useAccountsPayableContext } from 'templates/AccountsPayable/context'

import { theme } from 'styles/theme'

import Item from '../../Item'
interface ExpenseBeneficiaryParams {
  payee: AccountsPayablePayee
}
const ExpenseBeneficiary = ({ payee }: ExpenseBeneficiaryParams) => {
  const { setConfigurationDrawer, setExpenseDetailModal } =
    useAccountsPayableContext()
  const handleClickPayeerDetails = () => {
    setExpenseDetailModal({ isOpen: false, uuid: '' })
    setConfigurationDrawer({
      isOpen: true,
      payeeUuid: payee.uuid
    })
  }
  return (
    <>
      {payee?.name && (
        <Item
          textKey={'Beneficiário'}
          value={
            <Box
              display={'flex'}
              flexWrap={'wrap'}
              gap={'8px'}
              alignItems="center"
              onClick={handleClickPayeerDetails}
              sx={{ cursor: 'pointer' }}
            >
              {payee.name || ''}
              <Icon
                icon="open"
                width="21px"
                height="21px"
                ml="6px"
                sx={{ cursor: 'pointer', color: '#CBCBCB' }}
              />
            </Box>
          }
        />
      )}
      {payee?.phone && <Item textKey="Telefone" value={payee?.phone} />}
      {payee?.email && <Item textKey="E-mail" value={payee?.email} />}
      {payee?.notes && (
        <Box
          sx={{
            margin: '10px 0px 10px 0px'
          }}
        >
          <Typography
            variant="smLight"
            fontSize="14px"
            color={theme.palette.neutral[400]}
          >
            Observações:
          </Typography>

          <Typography
            variant="smLight"
            fontSize="14px"
            display="flex"
            color={theme.palette.neutral[400]}
            alignItems="center"
            mt="4px"
          >
            {payee?.notes}
          </Typography>
        </Box>
      )}
    </>
  )
}

export default ExpenseBeneficiary
